export default {
  pageTitle: "Application unsuccessful",
  pageHeading: "Your application was unsuccessful",
  pageCopy:
    "Thank you for applying for a personal loan with us. Your application has been unsuccessful and you will shortly receive a letter to explain this decision.",
  buttonLabel: "Go to M&S home page"
};
